import { getDocFlowMappingActiveFileType } from '../DocFlowMappingWidgets'

export function getFileType(file, t) {
  return `(${getDocFlowMappingActiveFileType(file, t)?.label})`
}
